import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-toolbar-item-search',
    templateUrl: './toolbar-item-search.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarItemSearchComponent {

    @HostBinding('class') string = 'eui-toolbar-item-search';

    constructor(
    ) {
    }
}
